import React from 'react';
import { setActiveCostCenters } from '../../../services/costCentersService.js';
import Autocomplete from '../../reusable/Autocomplete/Autocomplete.js';
import { useUser } from '../../../contexts/userContext.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';
import { USER_GROUP } from '../../../static/keyWords.js';
import { SESSION_STORAGE_KEYS } from '../../../static/localStorageStrings.js';

const NavigationCostCentersDropdown = () => {
  const { nameConventions } = useNameConventions();
  const { user, setUser, emptySelectedCostCenters, setEmptySelectedCostCenters} = useUser();

  const handleUpdate = async (vals) => {
    //since we have ridiculous requirement when no cost center is selected to evaluate like they are all selected we need this only for display purposes
    if (vals.length === 0) {
      setEmptySelectedCostCenters(true);
      vals=user.costCenters;
    } else {
      setEmptySelectedCostCenters(false);
    }

    const newUser = structuredClone(user);

    const selectedCostCenterIds = user.rawCostCenterArray.reduce((acc, cc) => {
      if (vals.includes(cc.name)) {
        acc.push(cc.id);
      }
      return acc;
    }, []);

    newUser.activeCostCenters = vals;
    newUser.activeCostCenterIds = selectedCostCenterIds;
    setUser(newUser);

    sessionStorage.setItem(SESSION_STORAGE_KEYS.ACTIVE_COST_CENTERS, JSON.stringify(vals));

    await setActiveCostCenters(vals);
  };

  return (  
    <>
      {user.activeCostCenters && (
        <section className="sidePadding">
          <p className="forge-typography--overline">{nameConventions ? nameConventions[USER_GROUP]?.pluralFormAlias : 'User Groups'}</p>
          <Autocomplete
            multiple
            options={user.costCenters}
            value={emptySelectedCostCenters ? [] : user.activeCostCenters}
            onChange={(vals) => {
              handleUpdate(vals);
            }}
            label={emptySelectedCostCenters ? '0 options selected' : ''}
            accLabel={'User group'}
            showClear
            syncPopupWidth={false}
            debounceValue={500}
            //forceCloseOnChange={true}
          />
        </section>
      )}
    </>
  );
};

export default NavigationCostCentersDropdown;
